/** Page / audit id for MT-QC-TASK-REPORT-001. */
export const QC_TASK_REPORT_PAGE_ID = 'MT-QC-TASK-REPORT-001';

/** Tab keys in URL and table toolbar (maps to API `req_status`). */
export const QC_TASK_REPORT_TABS = /** @type {const} */ ({
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
});
